var SDK_VERSION = '7.11.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
